module.exports = __webpack_public_path__ + "static/media/canlease-logo.71768a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/canlease-logo.png
// module id = 130
// module chunks = 0